'use client';

import { FC } from 'react';

import { Loader } from '@abg/kit-base';
import { usePageContext } from '@abg/web-core/context/page/client-provider';

import { useHandleAmazonRedirect } from '../../hooks';

import { UtilityHooksComponentProps } from './types';

export const AuthActivityProvider: FC<UtilityHooksComponentProps> = ({
  children,
}) => {
  const { brand } = usePageContext();
  // This hook handles case when user gets to
  // app with code from amazon
  // Case 1: login with amazon
  // Case 2: link account
  const { isLoading } = useHandleAmazonRedirect();

  return (
    <>
      {children}
      <Loader isImmediatelyActive={isLoading} brand={brand} />
    </>
  );
};
